<template>
  <div class="runtime-line-graph">
    <highcharts
      class="chart"
      :options="chartOptions"
    />
    <div class="sg-overlay" />
  </div>
</template>

<script>
import formatCycleRuntime from '@shared/lib/formatter/formatCycleRuntime';
import leadDetailMixin from '@shared/mixins/leadDetailMixin';

export default {
  name: 'RuntimeLineGraph',
  mixins: [leadDetailMixin],
  computed: {
    chartOptions() {
      return {
        title: {
          text: 'Runtime and Outside Temperature',
          style: {
            fontSize: 10,
            fontWeight: 600,
            fontFamily: 'Gilroy, sans-serif',
          },
        },
        chart: {
          type: 'line',
          zoomType: 'x',
          height: 250,
          spacingBottom: 15,
          spacingLeft: 10,
          spacingRight: 10,
          spacingTop: 15,
          animation: false,
        },
        credits: {
          enabled: false,
        },
        yAxis: [{
          labels: {
            formatter() {
              return formatCycleRuntime(this.value);
            },
            style: {
              fontSize: 8,
              fontFamily: 'Gilroy, sans-serif',
            },
          },
          title: {
            text: 'Runtime',
            style: {
              fontSize: 8,
              fontFamily: 'Gilroy, sans-serif',
            },
          },
          min: 32,
        }, {
          labels: {
            format: '{value}°F',
            style: {
              fontSize: 8,
              fontFamily: 'Gilroy, sans-serif',
            },
          },
          title: {
            text: 'OA Temp(°F)',
            style: {
              fontSize: 8,
              fontFamily: 'Gilroy, sans-serif',
            },
          },
          opposite: true,
        }],
        xAxis: [{
          categories: this.runtimeLineGraphData.cycleDate,
          tickInterval: 7,
          labels: {
            style: {
              fontSize: 8,
              fontFamily: 'Gilroy, sans-serif',
            },
          },
        }],
        legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'middle',
          itemStyle: {
            fontSize: 8,
            fontFamily: 'Gilroy, sans-serif',
          },
        },
        plotOptions: {
          series: {
            enableMouseTracking: false,
            label: {
              connectorAllowed: true,
            },
            connectNulls: true,
            animation: {
              duration: 0,
            },
            lineWidth: 1,
            marker: {
              radius: 2,
            },
          },
        },
        series: [{
          name: 'Runtime',
          color: '#D8534D',
          data: this.runtimeLineGraphData.runtimes,
        }, {
          name: 'OA Temp',
          color: '#66D383',
          data: this.runtimeLineGraphData.oaTemp,
          yAxis: 1,
        }],
        responsive: {
          rules: [{
            condition: {
              maxWidth: 2000,
            },
            chartOptions: {
              legend: {
                layout: 'horizontal',
                align: 'center',
                verticalAlign: 'bottom',
              },
            },
          }],
        },
      };
    },
  },
};
</script>

<style lang="scss">
.runtime-line-graph {
  border: 1px solid #EDF2FF;
  border-radius: 16px;
  margin: 20px 0;
  position: relative;
  width: 100%;
  .sg-overlay {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
}
</style>
